import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RootApplication from './RootApplication';
import './components/GlobalLuminanceCalibration.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RootApplication />
  </React.StrictMode>
);
